<template>
  <div class="staker-unstake">
    
    <div class="title">
      Stake FIS
    </div>
    <div v-if="warn" class="warn">
      Unable to stake, system is waiting for matching validators 
    </div>
    <div class="inputs-fis" :class="{'inputs-warn': warn}">
      <div class="transferrable">
        Transferrable FIS: {{ transferrableAmountShow }}
      </div>
      <div class="inputs-fis-amount">
        <input type="text" placeholder="FIS AMOUNT" v-model.trim="tokenAmount"  @keyup="checkAmountInput" />
        <div class="icon">
          <img src="../../assets/stafi.png" />
        </div>
      </div>
    </div>
    <div class="items">
      <div class="item">
        <div class="item-title">
          Estimated APR
        </div>
        <div class="item-value">
          {{ apr }}
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          You will get rFIS
        </div>
        <div class="item-value">
          {{ returnRtoken }}
        </div>
      </div>
    </div>
    <div class="stake-btn" :class="{'btn-active': stakeBtnActiveStatus == 1}" @click="stake">
      Stake
    </div>

  </div>
</template>

<script>
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import NumberUtil from '../../util/numberUtil.js';
import LocalStorage from '../../util/localStorage.js';
import Rpc from '../../util/rpc.js';
import Api from '../../util/SubstrateApi.js';
import {
  web3Enable,
  web3FromSource,
} from '@polkadot/extension-dapp';

const stakeBtnActive = 1;
const stakeBtnInActive = 0;

export default {
  name: 'stakerUnstaked',
  data() {
    let lang = window.localStorage.getItem('lang');
    return {
      lang: lang,
      transferrableAmount: 0,
      transferrableAmountShow: '--',
      tokenAmount: '',
      warn: false,
      ratio: '',
      returnRtoken: '--',
      stakeBtnActiveStatus: stakeBtnInActive,
      clickStake: false,
      poolLimit: 2000000000000000000,
      validPools: [],
      apr: '--'
    }
  },
  methods: {

    jumpToPool() {
      // this.$router.push({ name: 'ethpool', params: {source: 'stakerUnstaked'}});
    },

    validateAmount() {
      if (!this.tokenAmount || this.tokenAmount < 0) {
        this.tokenAmount = '';
        this.returnRtoken = '--';
        return false;
      }
      if (isNaN(this.tokenAmount)) {
        Toast({ 
          message: 'The deposited amount is invalid', 
          duration: 3000 
        });
        this.tokenAmount = '';
        this.returnRtoken = '--';
        return false;
      }

      return true;
    },

    checkAmountInput() {
      if (this.warn) {
        return;
      }
      if (this.tokenAmount && !isNaN(this.tokenAmount) && this.tokenAmount >= 0) {
         if (this.transferrableAmount > 0 && Number(this.tokenAmount) >= Number(this.transferrableAmount)) {
          Toast({ 
            message: 'The input amount exceeds your transferrable balance', 
            duration: 3000 
          });
          this.tokenAmount = '';
          this.returnRtoken = '--';
          this.stakeBtnActiveStatus = stakeBtnInActive;
          return;
        }

        this.stakeBtnActiveStatus = stakeBtnActive;
        if (this.ratio) {
          this.returnRtoken = NumberUtil.handleFisAmountToFixed(this.tokenAmount / this.ratio);;
        }
      } else {
        if (this.tokenAmount != '') {
          Toast({ 
            message: 'The deposited amount is invalid', 
            duration: 3000 
          });
        }
        this.tokenAmount = '';
        this.returnRtoken = '--';

        this.stakeBtnActiveStatus = stakeBtnInActive;
      }
    },

    stake() {
      if (this.clickStake) {
        return;
      }

      this.clickStake = true;

      if (!this.validateAmount()) {
        this.clickStake = false;
        this.stakeBtnActiveStatus = stakeBtnInActive;
        return;
      }

      if (this.tokenAmount <= 0) {
        Toast({ 
          message: 'The amount should be larger than 0', 
          duration: 3000 
        });
        return;
      }

      if (this.validPools.length <= 0) {
        Toast({ 
          message: 'No pool available, please try again later', 
          duration: 3000 
        });
        return;
      }

      const amount = NumberUtil.fisAmountToChain(this.tokenAmount.toString());
      
      let selectedPool = '';
      this.validPools.some(item => {
        if (Number(item.active) + amount <= this.poolLimit) {
          selectedPool = item.address;
          return true;
        }
      });

      if (!selectedPool) {
        Toast({ 
          message: 'The cumulative FIS amount exceeds the pool limit, please try again later!', 
          duration: 3000 
        });
        return;
      }

      Indicator.open('Loading...');

      web3Enable(Api.getWeb3EnalbeName());
      web3FromSource(Api.getPolkadotJsSource()).then(injector => {

        Api.createStafiApi().then(api => {

          let currentAccount = LocalStorage.getCurrentFisAccount();

          api.tx.rFis
              .liquidityBond(selectedPool, amount.toString())
              .signAndSend(currentAccount, { signer: injector.signer }, (result) => {
            
            if (result.status.isInBlock) {
              Indicator.close();
              this.clickStake = false;

              result.events
                .filter(({ event: { section } }) => section === 'system')
                .forEach(({ event: { data, method } }) => {
                  if (method === 'ExtrinsicFailed') {
                    const [dispatchError] = data
                    if (dispatchError.isModule) {
                      try {
                        const mod = dispatchError.asModule;
                        const error = data.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));

                        let message = 'Something is wrong, please try again later!';
                        if (error.name == 'NominateSwitchClosed') {
                          message = 'Unable to stake, system is waiting for matching validators';
                        } else if (error.name == 'LiquidityBondZero') {
                          message = 'The amount should be larger than 0';
                        } else if (error.name == 'PoolLimitReached') {
                          message = 'The cumulative FIS amount exceeds the pool limit, please try again later!';
                        }
                        Toast({ 
                          message: message, 
                          duration: 3000 
                        });
                      } catch (error) {
                        Toast({ 
                          message: error.message, 
                          duration: 3000 
                        });
                      }
                    }
                  } else if (method === 'ExtrinsicSuccess') {
                    Toast({ 
                      message: 'Stake successfully', 
                      duration: 3000 
                    });
                    setTimeout(() => {
                      this.$emit('stakeSuccess');
                    }, 3300);
                  }
                });
            } else if (result.isError) {
              Indicator.close();
              this.clickStake = false;
              Toast({ 
                message: result.toHuman(), 
                duration: 3000 
              });
            }

          }).catch((error) => {
            Indicator.close();
            this.clickStake = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });

        })
        .catch((error) => {
          Indicator.close();
          this.clickStake = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
        
      });


    }
  },

  created() {
    let currentAccount = LocalStorage.getCurrentFisAccount();
    if (currentAccount) {
      Api.createStafiApi().then(api => {
        api.query.rFis.nominateSwitch().then(result => {
          this.warn = !result.toJSON();
        });

        api.derive.balances.all(currentAccount).then(result => {
          if (result) {
            this.transferrableAmount = NumberUtil.fisAmountToHuman(result.availableBalance);
            this.transferrableAmountShow = NumberUtil.handleFisAmountToFixed(this.transferrableAmount);
          }
        });

        api.query.rFis.poolBalanceLimit().then(result => {
          this.poolLimit = result.toJSON();
        });

        api.query.rTokenRate.rate(0).then(result => {
          this.ratio = NumberUtil.fisAmountToHuman(result.toJSON());
        });

        api.query.rFis.pools().then(poolsData => {
          let pools = poolsData.toJSON();
          if (pools && pools.length > 0) {
            let count = 0;
            pools.forEach(pool => {
              api.query.staking.ledger(pool).then(ledgerData => {
                count++;
                let ledger = ledgerData.toJSON();
                if (ledger && ledger.active < this.poolLimit) {
                  this.validPools.push({
                    address: pool,
                    active: ledger.active
                  });
                }
                if (count >= pools.length) {
                  if (this.validPools.length <= 0) {
                    this.warn = true;
                  }
                }
              }).catch((error) => {});
            });
          }
        }).catch((error) => {});
      });

      Rpc.fetchStafiStakerApr({}).then(result => {
        if (result.status == '80000') {
          if (result.data && result.data.apr) {
            this.apr = result.data.apr + '%';
          }
        } 
      });

    } else {
      this.$router.push('/');
    }
    
  }

};
</script>

<style lang="scss">
@import "../../mixin.scss";

.staker-unstake {

  .warn {
    margin-top: 20px;
    color: #FD5D89;
  }

  .inputs-fis {
    margin-top: 30px;
  }

  .transferrable {
    font-size: 16px;
    color: #C4C4C4;
    text-align: right;
    margin-bottom: 10px;
  }

  .inputs-fis-amount {
    width: 442px;
    height: 50px;
    border-radius: 3.65px;
    border: 1px solid #BFBFBF;
    padding-left: 25px;
    position: relative;
    
    .icon {
      height: 36px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      img {
        height: 100%;
      }
    }
    input {
      font-size: 22px;
      font-weight: bold;
      width: 390px;
      height: 48px;
      background-color: #2B3239;
      border: 0;
      color: #fff;

      &:focus {
        outline: none
      }
    }
  }

  .inputs-warn {
    margin-top: 20px;
  }

  .stake-btn {
    cursor: pointer;
    margin-left: 361px;
    width: 110px;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    opacity: 0.4;
    border-radius: 21px;
    text-align: center;
  }

  .btn-active {
    opacity: 1;
  }
}
  
</style>